import { isRejectedWithValue } from "@reduxjs/toolkit";
import { createListenerMiddleware } from "@reduxjs/toolkit";
import { persistor } from "../../app/store/store";

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isRejectedWithValue,
  effect: async (action) => {
    if (["userLogin", "login"].includes(action?.meta?.arg?.endpointName)) return;

    if (action.payload?.status === 401) {
      await persistor.purge();
      window.location.href = "/login";
    }
  },
});

export default listenerMiddleware;

